import FamilleI18n from './Famille.i18n.js';
import Observer from '../../components/Observer/Observer'
import FiltrePlaque from '../../components/FiltrePlaque/FiltrePlaque.vue'
import Inter from '../../components/Inter/Inter.vue'
import FiltreFleur from '../../components/FiltreFleur/FiltreFleur.vue'
import ApercuPanier from '../../components/ApercuPanier/ApercuPanier.vue'
import FiltreLateral from '../../components/FiltreLateral/FiltreLateral.vue'
import BackToTop from 'vue-backtotop'
import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/antd.css'
import {
    mapActions,
    mapGetters,
    mapMutations,
} from 'vuex';

export default {

    components: {
        Observer,
        FiltrePlaque,
        FiltreFleur,
        BackToTop,
        VueSlider,
        Inter,
        ApercuPanier,
        FiltreLateral,
    },

    props: {},

    computed: {
        ...mapGetters([
            'search',
            'nb',
            'filtres',
            'tailles',
            'geometries',
            'materiaux',
            'bEtMs',
            'groupements',
            'prixMax',
            'prixMin',
            'firstPrixMax',
            'firstPrixMin',
            'article',
            'searchLoading',
            'cart',
            'priceHiddenMode',
            'recherche',
            'onlyNews'
        ]),

        param() {
            return this.$route.meta.param;
        },

        titre() {
            return this.$route.meta.titre;
        },

        minSlider() {
            return this.sliderPrix[0].toFixed(2)
        },
        maxSlider() {
            return this.sliderPrix[1].toFixed(2)
        },

    },

    data() {
        return {
            page: 1,
            max: 0,
            min: 0,
            oldMax: 0,
            oldMin: 0,
            firstLoad: true,
            rechercheCourante: '',
            saisieEnCours: 0,
            screenWidth: 1200,
            namePath: '',
            sliderPrix: [],
            formatter1: '{value} €',
            displayOptions: ['1x1', '2x2', '3x3'],
            sortOptions: ['-', 'Prix croissant', 'Taille', 'Désignation'],
            currentDisplay: '3x3',
            currentSort: '-',
            onlyNouveaute: 0,
            onlyPanier: false,
            cartInter: [],
            isPanierDisplayed: false,
            isFiltreDisplayed: false,
            styleHeight: '',
            dragEnCours: false,
            minField: 0,
            maxField: 0,
            componentKey: 0,
            hasMoreResult: true,
        };
    },

    watch: {
        rechercheCourante() {
            if (this.saisieEnCours > 0) {
                clearTimeout(this.saisieEnCours);
            }
            this.saisieEnCours = setTimeout(this.filtre, 1000, false)
        },
        currentSort() {
            if (this.param !== 'INTER.') {
                this.filtre(true)
            } else {
                this.filtre()
            }

        },
        isFiltreDisplayed() {
            if (this.isFiltreDisplayed) {
                this.$refs.apercuFiltre.style = this.styleHeight
            } else {
                this.$refs.apercuFiltre.style = "";
            }
        }
    },

    methods: {
        ...mapActions([
            'getSearch'
        ]),
        ...mapMutations([
            'setPrixMin',
            'setPrixMax',
            'setRecherche',
            'setArticle',
            'resetFiltres',
            'setOnlyNews'
        ]),
        toggleDisplayFiltre() {
            this.isFiltreDisplayed = !this.isFiltreDisplayed
        },
        /**
         * Fonction pour vérifier si une image existe.
         * @param {*} image_url
         * @returns
         */
        imageExists(image_url) {
            let img = new Image();
            img.src = "../" + image_url;
            if (img.height != 0) {
                return true;
            } else {
                return false;
            }
        },

        getDisplayMode() {
            if (this.currentDisplay === '1x1') {
                return 1
            } else {
                if (this.currentDisplay === '2x2') {
                    return 2
                } else {
                    return 3
                }
            }
        },

        getIntersInCart() {
            this.cartInter = [];
            this.cart.forEach(aItem => {
                if (aItem.Famille === "INTER.") {
                    this.cartInter.push(aItem)
                }
            })
        },

        /**
         * Fonction pour revenir à l'acceuil.
         */
        goToHome() {
            this.resetFiltres()
            this.$router.push({
                path: '/'
            })
        },

        /**
         * Fonction pour formatter le code article et enlever l'éventuel "/" en le remplaçant par "&".
         * @param {*} pCode
         * @returns
         */
        formatCodeArticle(pCode) {
            if (pCode.includes('/')) {
                pCode = pCode.replace('/', '$')
            }
            return pCode
        },

        /**
         * Fonction pour modifier le code article utilisé pour l'image. Remplacement de "/" par "-".
         * @param {*} pCode
         * @returns
         */
        formatCodeArticleForImage(pCode) {
            if (pCode.includes('/')) {
                pCode = pCode.replace('/', '-')
            }
            return pCode
        },

        /**
         * Fonction pour charger les articles.
         */
        load() {
            this.getSearch({
                page: this.page++,
                famille: this.param,
                prixMin: this.min,
                prixMax: this.max,
                onlyNouveaute: this.onlyNouveaute,
                recherche: this.rechercheCourante,
                sort: this.currentSort,
                firstSearch: true,
            }).then(res => {
                this.sliderPrix = [Math.floor(parseFloat(this.prixMin)), Math.ceil(parseFloat(this.prixMax))]
                this.max = parseFloat(this.firstPrixMax)
                this.min = parseFloat(this.firstPrixMin)
                this.firstLoad = false
                this.minField = this.sliderPrix[0]
                this.maxField = this.sliderPrix[1]
                this.oldMax = this.sliderPrix[1]
                this.oldMin = this.sliderPrix[0]
            });
        },

        outField(field) {
          if(field == 'min') {
            if (parseFloat(this.minField) > this.sliderPrix[1]) {
              this.minField = this.sliderPrix[1]
            }
            this.sliderPrix[0] = parseFloat(this.minField)
          } else {
            if (parseFloat(this.maxField) < this.sliderPrix[0]) {
              this.maxField = this.sliderPrix[0]
            }
            this.sliderPrix[1] = parseFloat(this.maxField)
          }
          this.componentKey += 1;
          this.filtre(true);
        },

        focus(fieldName) {
          document.getElementById(fieldName).focus()
        },

        scroll() {
            window.onscroll = () => {
                let bottomOfWindow = Math.max(window.pageYOffset, document.documentElement.scrollTop, document.body.scrollTop) + window.innerHeight === document.documentElement.scrollHeight
                if (bottomOfWindow && this.hasMoreResult && !this.searchLoading) {
                    var TopScroll = this.$refs.result.scrollTop;
                    var HeightScroll = this.$refs.result.scrollHeight;
                    var offHeightScroll = this.$refs.result.offsetHeight;
                    if (HeightScroll - TopScroll == offHeightScroll) {
                        this.getSearch({
                            page: ++this.page,
                            famille: this.param,
                            prixMin: this.sliderPrix[0],
                            prixMax: this.sliderPrix[1],
                            onlyNouveaute: this.onlyNouveaute,
                            recherche: this.rechercheCourante,
                            sort: this.currentSort
                        }).then((response) => {
                            if(response[0].next_page_url === null) {
                                this.hasMoreResult = false;
                            }
                        })
                    }
                }
            }
        },

        async intersected() {
            this.getSearch({
                page: this.page++,
                famille: this.param,
                prixMin: this.sliderPrix[0],
                prixMax: this.sliderPrix[1],
                onlyNouveaute: this.onlyNouveaute,
                recherche: this.rechercheCourante,
                sort: this.currentSort
            });
        },

        uncheck(filtre, indFiltre) {
            if (filtre.type == "bEtMs") {
                document.getElementById('bEtM' + filtre.libelle + 'Tous').checked = true;
                eval("this." + filtre.type).filter((el) => el.Libelle == filtre.libelle)[0].selected = false;
                this.filtres.splice(indFiltre, 1);
            } else {
                document.getElementById(filtre.type + filtre.libelle).checked = false;
                eval("this." + filtre.type).filter((el) => el.Libelle == filtre.libelle)[0].selected = false;
                this.filtres.splice(indFiltre, 1);
            }
            this.filtre();
        },

        filtreClick() {
            if (!this.dragEnCours) {
                this.filtre(true);
            }
        },

        /**
         * Fonction appelée lorsque l'un des inputs (prix min ou prix max) est défocusé.
         * Vérifie que la valeur existante au moment du dernier unfocus soit bien différente de l'actuelle.
         * Si différente, appelle la fonction de filtre.
         */
        filtreFromInput() {
            if ((this.oldMax !== this.sliderPrix[1]) || (this.oldMin !== this.sliderPrix[0])) {
                this.oldMax = this.sliderPrix[1]
                this.oldMin = this.sliderPrix[0]
                this.filtre(true)
            }
        },

        filtre(prix = false) {
            this.saisieEnCours = 0;
            this.search.splice(0, this.search.length);
            this.page = 1;
            this.hasMoreResult = true;
            if (!prix) {
                this.getSearch({
                    page: this.page,
                    famille: this.param,
                    prixMin: 0,
                    prixMax: 1000000,
                    onlyNouveaute: this.onlyNouveaute,
                    recherche: this.rechercheCourante,
                    sort: this.currentSort,
                    firstSearch: false,
                }).then(res => {
                    this.sliderPrix = [parseInt(this.prixMin), parseInt(this.prixMax)]
                    this.max = parseFloat(this.firstPrixMax)
                    this.min = parseFloat(this.firstPrixMin)
                    this.minField = this.sliderPrix[0]
                    this.maxField = this.sliderPrix[1]
                }).catch(err => {
                    console.log(err)
                })
            } else {
                this.dragEnCours = false;
                this.minField = this.sliderPrix[0]
                this.maxField = this.sliderPrix[1]
                this.getSearch({
                    page: this.page,
                    famille: this.param,
                    prixMin: this.sliderPrix[0],
                    prixMax: this.sliderPrix[1],
                    onlyNouveaute: this.onlyNouveaute,
                    recherche: this.rechercheCourante,
                    sort: this.currentSort
                }).then(res => {}).catch(err => {
                    console.log(err)
                })
            }

        },

        goToArticle(article) {
            this.setArticle(article);
            this.setRecherche(this.rechercheCourante)
            this.setOnlyNews(this.onlyNouveaute)
        },

        resizeWidth(e) {
            this.screenWidth = window.innerWidth
        },

        heightSuperiorWidth(src) {
            let img = new Image();
            img.src = src;
            return img.height >= img.width
        },

        setComponentHeight() {
            const top = this.$refs.zoneFiltre.getBoundingClientRect().top
            const top2 = this.$refs.apercuFiltre.getBoundingClientRect().top
            const hauteur = window.innerHeight - top;
            const hauteur2 = window.innerHeight - top2;
            this.styleHeight = "height:" + hauteur2 + "px;overflow-y:scroll;overflow-x:clip;";
            this.$refs.zoneFiltre.style = "height:" + hauteur + "px;overflow-y:scroll;overflow-x:clip;";
        }
    },

    filters: {
        formatNumber: (pValue) => {
            return parseFloat(pValue).toLocaleString('fr-FR', {
                style: "currency",
                currency: "EUR"
            })
        },
    },

    mounted() {
        // Si route ne contient pas le param "origin", alors tous les filtres peuvent être remis à zéro.
        if (this.$route.query.origin !== 'baniere' && this.$route.query.origin !== 'article') {
            this.resetFiltres()
        } else if (this.$route.query.origin === 'baniere') {
            // Cas où l'on vient de la bannière :
            // Traitement des filtres passées.
            // Les filtres sont déja configurés dans le store.
            // Seul les filtres "onlyNews" et "search" sont récupérés ici.
            // Traitement du filtre préconfiguré "onlyNews"
            if (this.$route.query.onlyNews === 'true') {
                this.onlyNouveaute = 1
            }
            // Traitement du filtre préconfiguré "search"
            if (this.$route.query.search) {
                this.rechercheCourante = this.$route.query.search
            }
        } else if (this.$route.query.origin === 'article') {
            // Cas où l'on vient de l'article
            // Récupération du champs de recherche
            this.rechercheCourante = this.recherche
            // Récupération de la valeur onlyNouveautés
            this.onlyNouveaute = this.onlyNews

        }
        this.sliderPrix = []
        this.search.splice(0, this.search.length);
        this.min = parseFloat(this.prixMin)
        this.max = parseFloat(this.prixMax)
        this.minField = this.min
        this.maxField = this.max
        this.sliderPrix = [Math.floor(parseFloat(this.prixMin)), Math.ceil(parseFloat(this.prixMax))]
        this.load();
        this.namePath = this.$route.path.substring(1);
        if (window.innerWidth >= 992) {
            this.currentDisplay = '3x3';
        } else {
            if (window.innerWidth < 576) {
                this.currentDisplay = '1x1';
            } else {
                this.currentDisplay = '2x2';
            }
        }
        window.addEventListener("resize", this.resizeWidth);
        this.screenWidth = window.innerWidth;
        this.setComponentHeight();
        this.scroll()
        if (this.param === 'INTER.') {
            this.getIntersInCart()
        }


    },

    i18n: FamilleI18n,

};
